import { get, post, del, put } from './_httpClient';

export async function getMentorInstitutions() {
  const { status, message, data } = await get('/clp/mentors/institutions');
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getMentorInstitutionById({ id }) {
  const { status, message, data } = await get(`/clp/mentors/institutions/${id}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getClassificationsHardskillByMentor() {
  const { status, message, data } = await get('/clp/mentors/classifications/hardskill');
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function addMentors({ payload }) {
  return post('/clp/mentors', payload);
}

export async function deleteMentorById({ id }) {
  const { status, message } = await del(`/clp/mentors/${id}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

export async function getMentors({ batchId, pageSize, page }) {
  const { status, message, data } = await get(
    `/clp/mentors?batchId=${batchId}&pageSize=${pageSize}&page=${page}`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getMentorById({ id }) {
  const { status, message, data } = await get(`/clp/mentors/${id}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function generateStudents({ id }) {
  const { status, message, data } = await post(`/clp/mentors/${id}/generated-students`, {});
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getMentorInstitutionOptions({ batchId }) {
  const { status, message, data } = await get(`/clp/mentors/institutions/option?batchId=${batchId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getMentorInstitutionDivisionOptions({ institutionsId, batchId }) {
  const { status, message, data } = await get(
    `/clp/mentors/institutions/${institutionsId}/divisions/option?batchId=${batchId}`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function checkMentorEmail({ email }) {
  const { status, message, data } = await get(`/clp/mentors/check-email?email=${email}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getMentorHistory({ id }) {
  const { status, message, data } = await get(`/clp/mentors/${id}/history`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getMentorDirectory({ search = '', pageSize = 10, page = 1 }) {
  const { status, message, data } = await get(
    `/clp/mentors/directory?search=${encodeURIComponent(search)}&pageSize=${pageSize}&page=${page}`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getMentorByUserId({ usersId }) {
  const { status, message, data } = await get(`/clp/mentors/users/${usersId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function updateMentorProfile({ usersId, payload }) {
  const { status, message } = await put(`/clp/mentors/users/${usersId}`, payload);
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

export async function addMentorDivision({ mentorsId, divisionInstitutionsId }) {
  const { status, message, data } = await post(`/clp/mentors/${mentorsId}/divisions`, {
    divisionInstitutionsId,
  });
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

